<template>
  <div class="card">
    <div class="card-body">
      <router-link
        class="close"
        :to="'/' + 'units/' + $i18n.locale"
      ></router-link>
      <h5 class="card-title">{{ $t('addNewUnit') }}</h5>
      <form @submit.prevent="createUnit">
        <p class="selectCountry">{{ $t('unitName') }}</p>
        <BaseInput
          class="field"
          v-model="unit.name"
          type="text"
          maxlength="35"
          :placeholder="$t('unitNameExample')"
          :class="{ 'error-boarder': $v.unit.name.$error }"
          @blur="$v.unit.name.$touch()"
        />
        <!--Form validation-->
        <template v-if="$v.unit.name.$error">
          <p v-if="!$v.unit.name.required" class="errorMessage">
            {{ $t('unitNameReq') }}
          </p>
        </template>

        <BaseInput
          class="field"
          type="text"
          maxlength="150"
          ref="autocomplete"
          id="address"
          v-model="unit.address"
          :placeholder="$t('address')"
          @blur="$v.unit.address.$touch()"
          :class="{ 'error-boarder': $v.unit.address.$error }"
        />
        <!--Form validation-->
        <template v-if="$v.unit.address.$error">
          <p v-if="!$v.unit.address.required" class="errorMessage">
            {{ $t('addressReq') }}
          </p>
        </template>

        <!-- <BaseInput
          class="field"
          v-model="unit.postal_code"
          type="number"
          :placeholder="$t('postalCode')"
          :class="{ 'error-boarder': $v.unit.postal_code.$error }"
          @blur="$v.unit.postal_code.$touch()"
        /> -->
        <!--Form validation-->
        <!-- <template v-if="$v.unit.postal_code.$error">
          <p v-if="!$v.unit.postal_code.required" class="errorMessage">
            {{ $t('postalCodeReq') }}
          </p>
        </template>

        <BaseInput
          class="field"
          v-model="unit.city"
          type="text"
          :placeholder="$t('city')"
          :class="{ 'error-boarder': $v.unit.city.$error }"
          @blur="$v.unit.city.$touch()"
        /> -->
        <!--Form validation-->
        <!-- <template v-if="$v.unit.city.$error">
          <p v-if="!$v.unit.city.required" class="errorMessage">
            {{ $t('cityReq') }}
          </p>
        </template>

        <p class="selectCountry">{{$t('selectCountry')}}</p>
        <country-select 
          v-model="unit.country" 
          :country="unit.country" 
          class="field inputStyle"
          topCountry="SI"
          countryName="true"
          autocomplete="true"
          removePlaceholder="true"
          usei18n="false"
          :class="field"
          @blur="$v.unit.country.$touch()"
          /> -->

        <!-- <BaseInput
          class="field"
          v-model="unit.country"
          type="text"
          :placeholder="$t('country')"
          :class="{ error: $v.unit.country.$error }"
          @blur="$v.unit.country.$touch()"
        /> -->

        <!--Form validation-->
        <!-- <template v-if="$v.unit.country.$error">
          <p v-if="!$v.unit.country.required" class="errorMessage">
            {{ $t('countryReq') }}
          </p>
        </template> -->

        <div class="optionalData">
          <p class="optional">{{ $t('optional') }}</p>
          <p style="text-align: left; margin-bottom: 2px;">
            {{ $t('addUnitRank') }}
          </p>
          <!-- <BaseSelect
            :options="categories"
            v-model="unit.category"
            class="field bgOptional"
          /> -->
          <BaseInput
            class="field bgOptional"
            v-model="unit.app_no"
            type="number"
            :placeholder="$t('appNo')"
          />
          <b-form-textarea
            class="field form-control bgOptional"
            aria-label="With textarea"
            v-model="unit.comments"
            maxlength="300"
            type="text"
            style=" height:100px;"
            :placeholder="$t('unitComments')"
          ></b-form-textarea>
        </div>
        <br />

        <button type="submit" class="action" :disabled="$v.$invalid">
          {{ $t('add') }}
        </button>
        <p v-if="$v.anyError" class="errorMessage">
          {{ $t('fillInReq') }}
        </p>
      </form>
      <sweet-modal icon="success" ref="modalSuccess">
        {{ $t('addedUnitConf') }}
      </sweet-modal>
      <sweet-modal icon="error" title="Oh nooo…" ref="modalError">
        {{ $t('errorMsg') }}
        <sweet-button slot="button">{{ $t('tryAgain') }}</sweet-button>
      </sweet-modal>
    </div>
  </div>
</template>

<script>
import NProgress from 'nprogress'
import { required } from 'vuelidate/lib/validators'

export default {
  metaInfo() {
    return {
      title: this.$i18n.t('addUnit')
    }
  },
  data() {
    return {
      categories: this.$store.state.unitCategories,
      unit: this.createFreshUnitObject(),
      country: '',
      widget: null
    }
  },
  validations: {
    unit: {
      category: {},
      name: { required },
      app_no: {},
      address: { required },
      // postal_code: { required },
      // city: { required },
      // country: { required },
      comments: {}
    }
  },
  async mounted() {
    this.widget = new window.google.maps.places.Autocomplete(
      document.getElementById('address'),
      { types: ['geocode'] }
    )
    this.widget.addListener('place_changed', () => {
      this.unit.address = document.getElementById('address').value
    })
  },
  methods: {
    createUnit() {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        NProgress.start()
        if (this.unit.category === '') this.unit.category = null
        if (this.unit.app_no === '') this.unit.app_no = null
        this.$store
          .dispatch('unit/createUnit', this.unit)
          .then(result => {
            // this.$refs.modalSuccess.open()
            this.$router.push({
              //ERROR: posting in db.json OK, routing at submit click NOT WORKING //
              name: 'unit',
              params: { unitId: result.insertId }
            })
            this.unit = this.createFreshUnitObject()
          })
          .catch(err => {
            this.errors = err.response.data.errors
            this.$refs.modalError.open()
          })
          .catch(() => {
            NProgress.done()
          })
      }
    },
    createFreshUnitObject() {
      const client = this.$store.state.client.client
      const id = Math.floor(Math.random() * 1000000)

      return {
        id: id,
        client: client,
        category: '',
        name: '',
        app_no: '',
        address: '',
        // postal_code: '',
        // city: '',
        // country: '',
        comments: '',
        productList: ''
      }
    }
  }
}
</script>

<style scoped>
.optionalData {
  background-color: var(--grey-light);
  border: 1px solid var(--grey);
  padding: 0 60px 30px 60px;
}
.optional {
  text-align: center;
  letter-spacing: 5px;
  margin-top: 1em;
  color: var(--bg);
}

form {
  width: 45%;
}

button.action {
  color: #fff;
  padding: 14px 64px;
  margin: 32px auto;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: bold;
  background-color: var(--primaryDark);
  cursor: pointer;
  border-radius: 5px;
  transition: opacity 0.4s;
}

button.action:hover {
  opacity: 0.9;
}

button:disabled,
button[disabled] {
  border: 1px solid #999999;
  background-color: #cccccc;
  color: #666666;
  cursor: context-menu;
}

.close {
  position: absolute;
  right: 15px;
  top: 15px;
  width: 25px;
  height: 25px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before,
.close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 33px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
.card-body {
  color: #454655;
}

.card-body {
  color: #454655;
}
.inputStyle {
  margin-bottom: 24px;
  display: block;
  width: 100%;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 0.375rem 0.75rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
.field {
  margin-bottom: 24px;
}

.card-title {
  font-size: 30px;
}
p {
  text-align: left;
}
.errorMessage {
  font-size: 0.8em;
  margin-top: -10px;
  color: var(--primaryDark);
}

.error-boarder {
  border: 2px solid var(--primaryDark);
}

.selectCountry {
  text-align: left;
  margin-bottom: 0px;
}
.bgOptional {
  background: rgb(252, 250, 250);
}

@media screen and (max-width: 560px) {
  form {
    width: 100%;
  }
  .optionalData {
    padding: 0 20px 10px 20px;
  }
}
</style>
